<template>
  <span>
  <v-container fluid fill-height class="home-hero" style="max-height: 100vh;">
  

      <v-layout align-left column pa-5>

   
      </v-layout> 

  </v-container>
  
  <!-- <v-container fluid fill-height pa-0 style="max-height: 100vh;">
    <v-transition name="fade" >
    <v-img v-transition="fade" key="img1" :src="bgimage" height="100%" />
    </v-transition>
  </v-container> -->

  </span>
</template>

<script>
export default {
    name: 'HomeHero',
    data() {
        return {
            bgimage: require('@/assets/img/cards/pazar-asnaf.jpg')
        };
    }
    // ,
    // components: {
    //     VueProgressiveImage: VueProgressiveImage
    // }
};
</script>

<style scoped>
.home-hero {
    /* background: url('http://source.unsplash.com/0BhSKStVtdM'); */
    /* background: url('~@/assets/img/water-ski-girl.png'); */
    background: url('~@/assets/img/cards/pazar-asnaf.jpg');  
    background-size: cover;
    width: 100%;
    height: 100%;
}
.fade-enter,
.fade-appear {
    opacity: 1;
}
.fade-enter-to,
.fade.appear-to {
    opacity: 0;
}
.fade-enter-active,
.fade-appear-active {
    transition: opacity 3s ease;
}

.text-block {
  background-color: rgba(202, 190, 190, 0.541);

}
</style>


